import { experiments } from '@/utils/experiment/manifest.ts';
import { useExperiment } from '@/utils/experiment/use-experiment.ts';

import { useEligibleForGenericSampleData } from '../controllers';
import { WizardTemplateOption } from '../utils/types';

export type ExperimentKeys = keyof typeof experiments;

export const useIsGenericSampleData = (template: WizardTemplateOption) => {
	const { userEligibleForGenericSampleData } = useEligibleForGenericSampleData(template);

	return {
		genericSampleDataIsEnabled: userEligibleForGenericSampleData,
	};
};

export const useIsJfindOnboardIllustrationRefresh = () => {
	const config = useExperiment(experiments.jfindOnboardIllustrationRefresh);
	return config.type === 'enrolled' && config.value;
};
